import { HudState, MatchStatus } from '../types'
import { Emitter } from '../utils/events'
import { STARTING_LIVES } from '../constants/game-config'

const HI_KEY = 'bluebob_hiscore'

function loadHi(): number {
  try {
    const n = Number(localStorage.getItem(HI_KEY) || 0)
    return Number.isFinite(n) ? n : 0 // corrupt/non-numeric storage must not poison hiScore with NaN
  } catch {
    return 0
  }
}
function saveHi(v: number): void {
  try {
    localStorage.setItem(HI_KEY, String(v))
  } catch {
    /* ignore */
  }
}

type Events = {
  hud: HudState
  status: MatchStatus
}

/** Mutable per-run game state + hi-score persistence. */
export class GameState {
  private bus = new Emitter<Events>()
  score = 0
  hiScore = loadHi()
  lives = STARTING_LIVES
  level = 1
  jellyRun = 0
  pearlsRemaining = 0
  powered = false
  powerRatio = 0
  streak = 0
  /** True when the player cleared the final level (story complete) — drives the ending. */
  won = false
  status: MatchStatus = 'ready'

  onHud(fn: (h: HudState) => void): () => void {
    return this.bus.on('hud', fn)
  }
  onStatus(fn: (s: MatchStatus) => void): () => void {
    return this.bus.on('status', fn)
  }

  setStatus(s: MatchStatus): void {
    this.status = s
    if (s === 'gameover') saveHi(this.hiScore) // persist the best score once, at run end
    this.bus.emit('status', s)
    this.emitHud()
  }

  resetRun(): void {
    this.score = 0
    this.lives = STARTING_LIVES
    this.level = 1
    this.jellyRun = 0
    this.streak = 0
    this.powered = false
    this.powerRatio = 0
    this.won = false
  }

  addScore(n: number): void {
    this.score += n
    // Track the best score live in memory; persisted once at game over (setStatus)
    // to avoid synchronous localStorage writes on every scoring frame.
    if (this.score > this.hiScore) this.hiScore = this.score
  }

  hud(): HudState {
    return {
      score: this.score,
      hiScore: this.hiScore,
      lives: this.lives,
      level: this.level,
      jelly: this.jellyRun,
      pearlsRemaining: this.pearlsRemaining,
      powered: this.powered,
      powerRatio: this.powerRatio,
    }
  }

  emitHud(): void {
    this.bus.emit('hud', this.hud())
  }
}
